import Dots from './Dots'

export default Dots